import { Component, OnInit } from '@angular/core';
import agency from '../../../../values/agency-info.json';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  agency = agency;

  constructor() { }

  ngOnInit(): void {}

}
